/* 🤖 this file was generated by svg-to-ts */
export const matIconGrid3X3: {
  name: 'grid-3-x-3';
  data: string;
} = {
  name: 'grid-3-x-3',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"/></svg>`
};
